<template>
    <v-container grid-list-md fluid>
        <v-flex xs12 sm12 md12 lg12 class="mrgB15">
            <v-card>
                <v-toolbar color="light-blue lighten-4" light>
                    <v-toolbar-title>Profile Update</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <!-- Login form -->
                    <v-form ref="form">
                        <v-text-field v-model="userPasswordModel.email" :type="'email'" :rules="userRules.email" label="Email" required @input="validatePasswordForm"></v-text-field>
                        <v-text-field v-model="userPasswordModel.password" :type="'password'" :rules="userRules.password" :counter="8" label="Password" required ></v-text-field>
                        <v-text-field v-model="userPasswordModel.cpassword" :type="'password'" :rules="userRules.cpassword" :counter="8" label="Confirm Password" required @input="validatePasswordForm"></v-text-field>
                        <v-btn :disabled='!isValidPasswordForm' depressed block large color="success" @click="checkUserProfile(false)">Update Password</v-btn>
                    </v-form>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-container>
</template>

<script>
    import UserService from "@/services/db/UserService.js";
    import CONSTANT from "@/services/Constant.js";
    import Utils from "@/services/Utils.js";

    export default {
        name: "Profile",
        data() {
            return {
                title: "Profile",
                isValidPasswordForm: false,
                userPasswordModel: {
                    email: "",
                    referCode: "",
                    referenceCode: "",
                    registrationDate: "",
                    showTutorial: true,
                    subscription: "basic",
                    userCurrentEmail: "",
                    userId: "",
                    password: "test1234"
                },
                userRules: {
                    email: [
                    v => !!v || "E-mail is required",
                    v =>
                        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
                        "E-mail must be valid"
                    ],
                    password: [
                    v => (v && v.length >= 8) || "Password must be atleast 8 characters"
                    ],
                    cpassword: [
                    v =>
                        (v && v.length >= 8) ||
                        "Confirm Password must be atleast 8 characters"
                    // v => (v && this.userPasswordModel.password == v) || 'Confirm password mismatch'
                    ]
                }
            };
        },
        created() {
            this.loadUserProfileInfo();
        },

        methods: {
            /*
            * Method to validate password form
            */
            validatePasswordForm() {
                if (
                    !this.userPasswordModel ||
                    (!Utils.isValidEmail(this.userPasswordModel.email) ||
                    this.userPasswordModel.password.length < 8 ||
                    this.userPasswordModel.cpassword.length < 8 ||
                    this.userPasswordModel.password != this.userPasswordModel.cpassword)
                ) {
                    this.isValidPasswordForm = false;
                } else {
                    this.isValidPasswordForm = true;
                }
            },

            /*
            * Method to load default user information
            */
            loadUserProfileInfo() {
                var _USER = JSON.parse(this.$store.getters.loginUser);

                UserService.getUserById(_USER.userId).then(user => {
                    this.userPasswordModel = Object.assign({}, user);
                    this.userCurrentEmail = this.userPasswordModel.email;
                    this.userPasswordModel.password = this.userPasswordModel.cpassword =
                    "test123";
                });
            },

            /*
            * Method to get user profile info
            */
            checkUserProfile() {
                if (this.isValidPasswordForm) {
                    var _profile = this.userPasswordModel;
                    delete _profile["cpassword"];

                    this.validateUserEmail((isValid) => {
                        if(isValid == null){
                            this.$store.commit("setAlert", {
                                isAlertError: true,
                                message: "Invalid email Id!"
                            });
                        } else if(isValid == false){
                            this.$store.commit("setAlert", {
                                isAlertError: true,
                                message: CONSTANT.MESSAGES.USER.EMAIL_ALREADY_EXISTS
                            });
                        } else {
                            this.saveProfile();
                        }
                    })
                    
                }
            },

            validateUserEmail(callback){
                if(this.userCurrentEmail == this.userPasswordModel.email){
                    callback(true);
                } else {
                    UserService.getUserByEmail(this.userPasswordModel.email)
                    .then(res => {

                        if (res == null) {
                            callback(null);
                        } else if (res == 0) {
                            callback(true);
                        } else {
                            callback(false);
                        }
                    })
                    .catch(() => {
                        this.$store.commit("setAlert", {
                            isAlertError: true,
                            message: CONSTANT.MESSAGES.USER.FAIL_GET_USER_PROFILE
                        });
                    });
                }
            },

            /*
            * Method to save user profile info
            */
            saveProfile() {
                if (this.isValidPasswordForm) {
                    var _profile = this.userPasswordModel;
                    
                    UserService.saveUserProfile(_profile)
                    .then(() => {
                        this.$store.commit("setAlert", {
                            isAlertSuccess: true,
                            message: CONSTANT.MESSAGES.USER.PROFILE_UPDATED
                        });
                        localStorage.setItem(CONSTANT.LOCAL_STORAGE.LOGIN_USER, JSON.stringify(_profile));
                    })
                    .catch(() => {
                        this.$store.commit("setAlert", {
                            isAlertError: true,
                            message: CONSTANT.MESSAGES.USER.PROFILE_UPDATED_FAIL
                        });
                    });
                }
            }
        }
    };
</script>
